import { createPortal } from 'react-dom';
import './Modal.css';

const Modal = ({ title, isOpen, onClose, children, showTitleBar = true, className = '', overlayStyle = {}, contentStyle = {}, bodyStyle = {}, portal = false }) => {
  if (!isOpen) {
    return null;
  }

  const overlay = (
    <div className={`modal-overlay ${className}`} style={overlayStyle}>
      <div className="modal-content" style={contentStyle}>
        {showTitleBar && (
          <div className="modal-header">
            <div className="modal-title">{title}</div>
            <button className="modal-close-button" onClick={onClose}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"/>
              </svg>
            </button>
          </div>
        )}
        {!showTitleBar && (
          <div className="modal-close-button-alt" onClick={onClose}>
             <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-x-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
              </svg>
          </div>
        )}
        <div className="modal-body" style={bodyStyle}>
          {children}
        </div>
      </div>
    </div>
  );

  return portal ? createPortal(<div className="th">{overlay}</div>, document.body) : overlay;
};

export default Modal;
